/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, July 5th 2024, 6:07:05 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { CONDITION_LOGIC_TYPES } from "lib/schemas";
import { OSDropDown } from "ui-widgets";

type FieldDependencyFormProps = {
  prefix?: string;
  suffix?: string;
  conditionLogicType: keyof typeof CONDITION_LOGIC_TYPES;
  onChangeConditionLogicType: (chosenValue: keyof typeof CONDITION_LOGIC_TYPES) => void;
};

export const FieldDependencyLogicTypeSelector = ({
  prefix,
  suffix,
  conditionLogicType,
  onChangeConditionLogicType,
}: FieldDependencyFormProps) => {
  return (
    <Stack direction="row" spacing={2} className="condition-logic-type">
      {prefix}
      <OSDropDown
        value={conditionLogicType}
        options={CONDITION_LOGIC_TYPES}
        onChangeCallBack={onChangeConditionLogicType}
      />
      {suffix}
    </Stack>
  );
};
